export function formatDate(value?: string | null): string {
  if (!value) return 'Not available';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Not available' : new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'medium', timeStyle: 'short', timeZone: 'UTC'
  }).format(date) + ' UTC';
}

export function formatMetric(key: string, value: number | null): string {
  if (value === null || value === undefined) return 'Missing';
  if (key.endsWith('_cents')) {
    return new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value / 100);
  }
  if (key.includes('mrr') || key.includes('eur')) {
    return new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value);
  }
  if (key.includes('seconds')) {
    if (value < 60) return `${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 }).format(value)} sec`;
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = Math.round(value % 60);
    return hours ? `${hours}h ${minutes}m` : `${minutes}m ${seconds}s`;
  }
  return new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(value);
}

export function labelize(value: string): string {
  return value.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}
